<div role="rowgroup" class="border-default border-t">
  <div role="row" [style]="tableColumnStyles()">
    @for (i of range(unusedLeftColumns()); track `unused-left-${i}`) {
      <div role="cell" class="table-frozen-cell bg-surface"></div>
    }

    <!-- Summary Cells -->
    @for (column of columns(); track column.key) {
      <div
        role="cell"
        class="group border-weak text-text-primary text-2xs relative border-r px-2.5 py-1.5">
        @if (getSummaryForColumn(column); as summary) {
          <div #columnData>
            <div class="text-text-tertiary text-[10.5px]">
              {{ getPrimarySummaryLabel(summary) }}
            </div>
            <span class="text-text-primary font-mono text-xs font-semibold">
              {{ getPrimarySummaryValue(summary) }}
            </span>
            @if (getPrimarySummaryUnit(summary); as unit) {
              <span class="text-text-tertiary ml-1 font-mono text-xs">{{ unit }}</span>
            }
          </div>
          <app-tooltip
            class="capitalize"
            [target]="columnData"
            [title]="column.label"
            [content]="getTooltipContent(summary)"
            [interactive]="true"
            [position]="'top-start'" />
        } @else {
          <span class="text-text-tertiary">-</span>
        }
      </div>
    }

    @for (i of range(unusedRightColumns()); track `unused-right-${i}`) {
      <div role="cell"></div>
    }
  </div>
</div>
